import React, { ReactNode, useState } from 'react'
import styled from 'styled-components'
import { Info } from '../icons'
import { TooltipCloud } from './TooltipCloud'
import { Colors } from '../../constants'

interface Props {
  children: ReactNode
  className?: string
  right?: boolean
  large?: boolean
}

export function Tooltip(props: Props) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <InfoStyled large={props.large} />
      </Button>
      {open && (
        <TooltipCloudStyled className={props.className} right={props.right} onClose={() => setOpen(false)}>
          {props.children}
        </TooltipCloudStyled>
      )}
    </>
  )
}

const Button = styled.button`
  margin-left: 5px;
  padding: 0;
  display: inline-block;
  background: none;
  border: 0;
  outline: 0;
  cursor: pointer;

  &.active {
    color: ${Colors.White};
  }

  &:hover {
    color: ${Colors.White};
  }
`

const InfoStyled = styled(Info)<{ large?: boolean }>`
  position: relative;
  top: -1px;
  color: #7f7f7f;
  width: ${({ large }) => (large ? '14px' : '10px')};
  height: ${({ large }) => (large ? '14px' : '10px')};
`

const TooltipCloudStyled = styled(TooltipCloud)<{ right?: boolean }>`
  bottom: -15px;
  right: ${({ right }) => (right ? 'unset' : '15px')};
  left: ${({ right }) => (right ? '5px' : 'unset')};

  a {
    color: ${Colors.Hover};
  }
`
